import { saveZipFile } from 'src/utilities/saveZipFile';

export interface UseDownloadPdfFileProps {
  downloadUrl: string;
  onError?: () => void;
  onDownload: () => void;
}
export interface UseDownloadZipFile {
  getZipFileFromS3: () => void;
}

export const useDownloadZipFile = ({
  downloadUrl,
  onError,
  onDownload,
}: UseDownloadPdfFileProps): UseDownloadZipFile => {
  async function getZipFileFromS3() {
    try {
      const response = await fetch(downloadUrl);
      const data = await response.arrayBuffer();
      const zipFilename = `Grubhub_Receipts.zip`;
      saveZipFile(data, zipFilename);
      onDownload();
    } catch (e) {
      onError();
    }
  }
  return {
    getZipFileFromS3,
  };
};
